module.exports = __webpack_public_path__ + "img/class_early.2ff9e993.jpg";